define('formkit/behavior/go.to.previous.section.behavior',['require','exports','module','marionette'],function(require, exports, module) {
  var Mn = require('marionette');


  var GoToPreviousSectionBehavior = Mn.Behavior.extend({
    defaults: {
      form: null,

      eventName: 'press',

      // set to false if button visibillity should not be affected
      toggleButtonDisabled: true
    },

    initialize: function() {
      this.listenTo(this.view, this.getOption('eventName'), this.onEvent);

      if (this.getOption('toggleButtonDisabled')) {
        this.once('render', function() {
          this.view.disabled = this.isFirstSection(this.getOption('form').getActiveSectionIndex());
        });

        this.listenTo(this.getOption('form'), 'change:activeSectionIndex', function(newActiveSectionIndex, oldActiveSectionIndex) {
          this.view.disabled = this.isFirstSection(newActiveSectionIndex);
        });
        this.listenTo(this.getOption('form'), 'formObject:disclose', function(tempalateObjectModel, value) {
          this.view.disabled = this.isFirstSection(this.getOption('form').getActiveSectionIndex());
        });
      }
    },

    onEvent: function() {
      var currentActiveSectionIndex = this.getOption('form').activeSectionIndex || 0;

      if (this.previousSectionExists(currentActiveSectionIndex)) {
        var previousSectionIndex = this.getPreviousVisibleSectionIndex(currentActiveSectionIndex);
        this.getOption('form').setActiveSectionIndex(previousSectionIndex);
      }
    },

   previousSectionExists: function(currentActiveSectionIndex) {
     var sections = this.getOption('form').getTemplateModel().get('children');
     var prevSectionIndex = this.getPreviousVisibleSectionIndex(currentActiveSectionIndex);
     return (prevSectionIndex >= 0);
   },

   getPreviousVisibleSectionIndex: function(currentActiveSectionIndex) {
     var form = this.getOption('form') || this.view.form;
     var sections = form.getTemplateModel().get('children');

     for (var i = currentActiveSectionIndex - 1; i >= 0; i--){
       var section = sections.at(i);
       if (form.util.isVisible(section)) {
         return i;
       }
     }
     return -1;
   },

   isFirstSection: function(sectionIndex) {
     return !this.previousSectionExists(sectionIndex);
   }
  });

  module.exports = GoToPreviousSectionBehavior;
});

